import BaseApiRequest from "./BaseApiRequest";
import { APPLICANT_CREATE_REQUEST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class ApplicantCreateRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = APPLICANT_CREATE_REQUEST_URL;

  constructor(reqData) {
    super();
    this.body = reqData;
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
